import React, { useEffect, useState } from 'react'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import photo1 from '../images/mcast-03.png'
import Header from './global/Header'
import { Link, useParams } from 'react-router-dom'
import axios from 'axios'
import { baseUrl } from '../consts/consts'
import Loader from './global/Loader'
import Footer from './global/Footer'
import { Image } from 'react-bootstrap'
import { excerpt } from '../utils/helper'

const SingleNews = () => {
  const [loader, setLoader] = useState(false)
  const [news, setNews] = useState(null)
  const [breakingNews, setBreakingNews] = useState([])

  const params = useParams()
  const { slug } = params

  useEffect(() => {
    getNews(slug)
    getBreakingNews()
  }, [slug])

  const getNews = async (id) => {
    try {
      setLoader(true)
      const { data } = await axios.get(`${baseUrl}/blogs/slug/${id}`)

      setNews(data.data)
      setLoader(false)
    } catch (error) {
      setLoader(false)
    }
  }

  const getBreakingNews = async () => {
    try {
      setLoader(true)
      const { data } = await axios.get(`${baseUrl}/blogs/tags/right-slider`)

      setBreakingNews(data.data.blogs)
      setLoader(false)
    } catch (error) {
      setLoader(false)
    }
  }
  return (
    <>
      <Header />
      {loader && <Loader />}
      {!loader && news && (
        <>
          <div className='Credentials' style={{ textAlign: 'center' }}>
            <Container>
              <div className='single-news-title-container my-5'>
                <h1 className='bold'>{news.title}</h1>
                <div className='single-news-breadcrumb-container'>
                  <div>
                    <Link to='/news'>News</Link>/
                  </div>
                  <div>
                    <p>{news.slug}</p>
                  </div>
                </div>
              </div>
            </Container>
          </div>
          <div className='single-news-offered'>
            <Container>
              <Row>
                <Col md='8' style={{marginBottom: 30}}>
                  <div className='single-news-container'>
                    <h2 className='bold'>{news.title}</h2>
                    <div className='single-news-image-container'>
                      <Image
                        src={news.featured_image}
                        className='single-news-image'
                        alt={news.title}
                      />
                    </div>
                    <hr />
                    <div className='single-news-small-description'>
                      <h3>{news.small_description}</h3>
                    </div>
                    <div
                      className='single-news-description'
                      dangerouslySetInnerHTML={{ __html: news.description }}
                    />
                    <hr />
                    <div style={{textAlign: 'right'}}><Link to='/news' className='btn btn-success'>More News</Link></div>
                  </div>
                </Col>
                <Col md='4'>
                  <div className='single-news-container'>
                    {breakingNews.length > 0 &&
                      breakingNews.map((news, i) => (
                        <>
                          <div
                            className='breaking-news-container'
                            key={news.id}
                          >
                            <div className='breaking-news-image-container'>
                              <Image
                                src={news.featured_image}
                                alt={news.title}
                              />
                            </div>
                            <div className='breaking-news-description'>
                              <p>{excerpt(news.small_description, 50)}</p>
                            </div>
                          </div>
                          {i === breakingNews.length - 1 ? '' : <hr />}
                        </>
                      ))}
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </>
      )}

      <Footer />
    </>
  )
}

export default SingleNews
